import styled from 'styled-components';

export const TabSwitcherContainer = styled.div`
  position: relative;
`;

export const TabSwitcherTabsContainer = styled.div``;
